module.exports = __webpack_public_path__ + "static/media/fondo_orquesta.e28aec24.jpg";